import { call, fork, select, join } from 'redux-saga/effects'
import defaultSettings, { addDefaultSettings } from 'helpers/defaultSettings'
import createDocument from 'helpers/databases/createDocument'
import { getProjectUpdatedAt, getSettings } from 'sagas/setupProjectsSaga/findBySelector'
import { databaseSelector } from 'selectors'
import projectWithModel from 'sagas/setupProjectsSaga/projectWithModel'
import cameraWithModel from 'sagas/setupProjectsSaga/cameraWithModel'
import mostRecentProject from 'sagas/setupProjectsSaga/mostRecentProject'

function * getProject(db) {
  const { project, projectsLength } = yield call(mostRecentProject, db)
  return { project, projectsLength }
}

function * getModelProject(db, model) {
  const projects = yield call(getProjectUpdatedAt, db)
  const project = projectWithModel(cameraWithModel(model))
  const idAndRev = yield call(createDocument, db, project)
  return {
    project: { ...project, ...idAndRev },
    projectsLength: projects.length
  }
}

export default function * getProjectsAndSettings(model) {
  const { database } = yield select(databaseSelector)
  const task1 = yield fork(model ? getModelProject : getProject, database, model)
  const task2 = yield fork(getSettings, database)

  yield join(task1, task2)
  const { project, projectsLength } = task1.result()
  const settings = task2.result()

  if (!settings) {
    yield call(createDocument, database, defaultSettings)
    return { project, projectsLength, settings: defaultSettings }
  } else return { project, projectsLength, settings: addDefaultSettings(settings) }
}



// WEBPACK FOOTER //
// ./src/sagas/setupProjectsSaga/getProjectsAndSettings.js